import { render } from "./studentinfo.vue?vue&type=template&id=3366d899&scoped=true"
import script from "./studentinfo.vue?vue&type=script&lang=js"
export * from "./studentinfo.vue?vue&type=script&lang=js"

import "./studentinfo.vue?vue&type=style&index=0&id=3366d899&scoped=true&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3366d899"]])

export default __exports__